module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/airstrike-reward-50.8bb35ead.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/airstrike-reward-50.png
// module id = 3773
// module chunks = 11